/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';

import type { ReferenceChatAvailabilitiesResponse } from './model';

export const getGetReferenceChatAvailabilitiesResponseMock =
  (): ReferenceChatAvailabilitiesResponse => ({
    special_allocation_taxes: true,
    prefectural_special_allocation_taxes: false,
    national_grants: true,
    prefectural_grants: false,
    revenue_expenditure_account_items: true,
  });

export const getGetReferenceChatAvailabilitiesMockHandler = (
  overrideResponse?:
    | ReferenceChatAvailabilitiesResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<ReferenceChatAvailabilitiesResponse> | ReferenceChatAvailabilitiesResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/references/availabilities',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetReferenceChatAvailabilitiesResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [getGetReferenceChatAvailabilitiesMockHandler()];
